import { defineStore } from 'pinia';
import elemento_grupo_model from '@/shared/models/elemento_grupo_model.js';
import elemento_grupo_service from '@/services/elemento_grupo_service.js';

export const useElementoGrupoStore = defineStore('elementoGrupoStore', {
  state: () => ({
    elementoGrupo: null,
    elementosGrupo: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllElementosGrupoHTTP(params) {
      const searchParams = new URLSearchParams({ page: +this.page, ...this.filters, ...params });
      const result = await elemento_grupo_service.findAll(searchParams.toString());
      if (result && result.data) {
        this.elementosGrupo = [...result.data];
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findElementoGrupoPorCodigoHTTP(Codigo) {
      const result = await elemento_grupo_service.findByCodigo(Codigo);
      if (result && result.data) {
        this.elementoGrupo = { ...elemento_grupo_model, ...result.data };
      }
    },
    async saveElementoGrupo() {
      if (this.elementoGrupo.Codigo) {
        await this.updateElementoGrupoHTTP();
      } else {
        await this.createElementoGrupoHTTP();
      }
    },
    async createElementoGrupoHTTP() {
      await elemento_grupo_service.create(this.elementoGrupo);
    },
    async updateElementoGrupoHTTP() {
      await elemento_grupo_service.update(this.elementoGrupo.Codigo, this.elementoGrupo);
    },
    async deleteElementoGrupoPorCodigoHTTP(Codigo) {
      await elemento_grupo_service.delete(Codigo);
    },
    setPage(page) {
      this.page = page;
    },
    async firstElementoGrupo(page = 1) {
      this.setPage(page);
      this.emptyList();
      await this.findAllElementosGrupoHTTP();
    },
    emptyList() {
      this.elementosGrupo = [];
    },
    selectElementoGrupo(codigo) {
      const index = this.elementosGrupo.findIndex((item) => item.Codigo === codigo);
      if (index !== -1) {
        this.elementoGrupo = { ...this.elementosGrupo[index] };
      }
    },
    unselectElementoGrupo() {
      this.elementoGrupo = null;
    },
  },
});
